var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('nav-bar'),_c('v-main',{staticClass:"grey lighten-3"},[_c('v-container',[_c('v-row',[_c('v-col',[_c('v-sheet',{staticClass:"pa-5",attrs:{"min-height":"70vh","rounded":"lg"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }